export default __webpack_public_path__ + "static/media/hht1_ep14_minisitcom_04.be222be0.png";